import { type } from 'arktype';
import { createPaginatedResponseSchema } from '../shared/pagination';

/**
 * Contrato del catálogo `category`: seis filas fijas (colores/emoji de categoría), sin
 * campos de auditoría — es un catálogo cerrado, no una entidad con ciclo de vida.
 */
export const categoryResponseSchema = type({
	// Hex de seis dígitos con almohadilla, p. ej. `#1A2B3C`.
	colorHex: /^#[0-9a-fA-F]{6}$/,
	emoji: 'string',
	id: 'string.uuid',
	name: 'string',
	slug: 'string',
}).onUndeclaredKey('delete');

export type CategoryResponse = typeof categoryResponseSchema.infer;

export const createCategorySchema = type({
	colorHex: /^#[0-9a-fA-F]{6}$/,
	emoji: 'string',
	name: 'string',
	slug: 'string',
}).onUndeclaredKey('delete');

export type CreateCategory = typeof createCategorySchema.infer;

export const updateCategorySchema = createCategorySchema.partial();

export type UpdateCategory = typeof updateCategorySchema.infer;

export const categoryPaginatedResponseSchema = createPaginatedResponseSchema(categoryResponseSchema);

export type CategoryPaginatedResponse = typeof categoryPaginatedResponseSchema.infer;
